import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../elements/Box';
import Col from '../../elements/Col';
import Row from '../../elements/Row';
import Text from '../../elements/Text';
import Icon from '../../elements/Icon';

const LegendHotelLowRateCalendar = (props) => {
  const {
    legendToday,
    legendPrice,
    legendCheckAvailability,
    showLegendPrice,
    showLegendToday,
    showCheckAvailability,
    columnLegendTodaySetting,
    columnLegendPriceSetting,
    columnCheckAvailabilitySetting,
    legendTodayBox,
    legendPriceBox,
    legendCircleInsidePriceBox,
    legendCheckAvailabilityIcon
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Row ariaHidden={true} className={`${className} fr-clearfix`} style={style} dataTestId="legend">
      {showLegendToday && (
        <Col style={{ display: 'flex' }} {...columnLegendTodaySetting}>
          <Box
            style={{
              height: '20px',
              width: '20px'
            }}
            {...legendTodayBox}
          ></Box>
          <Text {...legendToday} floatLeft>
            {translate('cmp-legend-today', 'Today')}
          </Text>
        </Col>
      )}
      {showLegendPrice && (
        <Col style={{ display: 'flex' }} {...columnLegendPriceSetting}>
          <Box
            style={{
              background: '#D7DEFD',
              height: '20px',
              width: '20px'
            }}
            {...legendPriceBox}
          >
            <Box
              style={{
                background: '#00855C',
                height: '9px',
                width: '9px',
                '-moz-border-radius': '50%',
                '-webkit-border-radius': '50%',
                'border-radius': '50%',
                'margin-top': '6px',
                'margin-left': '6px'
              }}
              {...legendCircleInsidePriceBox}
            ></Box>
          </Box>
          <Text {...legendPrice} floatLeft marginRight="1">
            {translate('cmp-legend-lowest-price', 'Lowest Price')}
          </Text>
        </Col>
      )}

      {showCheckAvailability && (
        <Col style={{ display: 'flex' }} {...columnCheckAvailabilitySetting}>
          <Icon ariaHidden={true} icon="searchV2" size="20" {...legendCheckAvailabilityIcon}></Icon>
          <Text {...legendCheckAvailability} floatLeft marginRight="1">
            {translate('cmp-legend-check-availabilty', 'Check Availabilty')}
          </Text>
        </Col>
      )}
    </Row>
  );
};

LegendHotelLowRateCalendar.propTypes = {
  /**
   * Props of legendPrice
   */
  legendPrice: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of legendToday
   */
  legendToday: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the showLegendPrice item
   */
  showLegendPrice: PropTypes.bool,
  /**
   * Turn off or on the showLegendToday item
   */
  showLegendToday: PropTypes.bool,
  /**
   * Translation key of the legendPrice
   */

  showCheckAvailability: PropTypes.bool,
  legendPriceLabelKey: PropTypes.string,
  /**
   * Translation key of the legendToday
   */
  legendTodayLabelKey: PropTypes.string
};

LegendHotelLowRateCalendar.defaultProps = {
  legendPriceLabelKey: 'cmp-legend-lowest-price',
  legendTodayLabelKey: 'cmp-legend-today',
  legendPrice: {},
  legendToday: {},
  showLegendPrice: true,
  showLegendToday: true,
  showCheckAvailability: true
};

export default LegendHotelLowRateCalendar;
